export default __webpack_public_path__ + "static/media/CozyHome.2358a4e4.jpg";